<template>
	<div class="center_right">
		<div class="center_commNav">
			<div class="center_commNavItem" @click="activeName=item.id" :class="{'active':activeName==item.id}" v-for="(item,index) in commNavs">{{item.name}}</div>
		</div>
		<div v-show="activeName=='1'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="实验名称：">
							<el-input v-model="labTestname" placeholder="请输入实验名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="实验类型：">
							<el-select :popper-append-to-body='false' v-model="labTesttypeId" placeholder="请选择实验类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="labTestCurrent(1)" type='primary'>搜索</el-button>
								<el-button @click='clearLabTestFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="labTestData" border stripe>
					<emptymain slot='empty' :emptylist='labTestData'></emptymain>
					<el-table-column label="实验封面" align='center'>
						<template slot-scope="scope">
							<div class="center_labinfo pointer" @click="getLabInfo(scope.row,3)">
								<img :src="baseurl + scope.row.cover" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验名称" prop="name" align='center' :show-overflow-tooltip='true'>
						<template slot-scope="scope">
							<span class=" pointer" @click="getLabInfo(scope.row,3)">{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="实验类型" prop="typeName" align='center'>
					</el-table-column>
					<el-table-column label="学习次数" prop="clickNum" align='center'>
						<template slot-scope="scope">
							<span class="warningColor">{{scope.row.studyCount || 0}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='viewSimulation(scope.row,scope.row.vrResourceStudy)' :disabled='!scope.row.vrResourceStudy'>进入学习</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="labTestCurrent" :current-page="labTestcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="labTesttotal">
				</el-pagination>
			</div>
		</div>
		<div v-show="activeName=='2'">
			<div class="center_filter">
				<div class="center_filterInput">
					<el-form :inline="true" label-width="100px">
						<el-form-item label="实验名称：">
							<el-input v-model="labExamname" placeholder="请输入实验名称" clearable></el-input>
						</el-form-item>
						<el-form-item label="实验类型：">
							<el-select :popper-append-to-body='false' v-model="labExamtypeId" placeholder="请选择实验类型" clearable>
								<el-option :label="item.name" :value="item.id" v-for='(item,index) in typeList'></el-option>
							</el-select>
						</el-form-item>
						<el-form-item>
							<div class="center_filterBtns">
								<el-button @click="labExamCurrent(1)" type='primary'>搜索</el-button>
								<el-button @click='clearLabExamFilter'>重置</el-button>
							</div>
						</el-form-item>
					</el-form>
				</div>
				<div class="center_filterBtns">
				</div>
			</div>
			<div class="center_tables center_labtables">
				<el-table :data="labExamData" ref='centerTable' border stripe>
					<emptymain slot='empty' :emptylist='labExamData'></emptymain>
					<el-table-column type="expand">
						<template slot-scope="scopeFather">
							<div class="center_tableAppend">
								<el-table :data="scopeFather.row.paperList || []" border stripe v-if="scopeFather.row.vrResourceExamine && scopeFather.row.vrResourceExamine.version=='1.0.0'">
									<emptymain slot='empty' :emptylist='scopeFather.row.paperList || []'></emptymain>
									<el-table-column label="用时（秒）" prop="timeUsed" align='center'>
										<template slot-scope="scope">
											{{scope.row.status == '1'?scope.row.timeUsed:'未完成'}}
										</template>
									</el-table-column>
									<el-table-column label="得分" prop="score" align='center'>
										<template slot-scope="scope">
											{{scope.row.status == '1'?scope.row.score:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="开始时间" prop="startTime" align='center'>
										<template slot-scope="scope">
											{{scope.row.status == '1'?scope.row.startTime:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="结束时间" prop="endTime" align='center'>
										<template slot-scope="scope">
											{{scope.row.status == '1'?scope.row.endTime:'-'}}
										</template>
									</el-table-column>
									<el-table-column label="操作" align='center'>
										<template slot-scope="scope">
											<span class="center_getInfo" @click='scoreSimulation(scope.row,scopeFather.row)' v-if="scope.row.status == '1'">查看详情</span>
											<span class="center_getInfo dis" v-if="scope.row.status != '1'">查看详情</span>
										</template>
									</el-table-column>
								</el-table>
								<el-table :data="scopeFather.row.dataList || []" border stripe v-if="scopeFather.row.vrResourceExamine && scopeFather.row.vrResourceExamine.version=='2.0.0'">
									<emptymain slot='empty' :emptylist='scopeFather.row.dataList || []'></emptymain>
									<el-table-column label="用时（秒）" prop="timeUsed" align='center'>
									</el-table-column>
									<el-table-column label="得分" prop="score" align='center'>
									</el-table-column>
									<el-table-column label="考核时间" prop="createTime" align='center'>
									</el-table-column>
									<el-table-column label="操作" align='center'>
										<template slot-scope="scope">
											<span class="center_getInfo" @click='scoreSimulation(scope.row,scopeFather.row)'>查看详情</span>
										</template>
									</el-table-column>
								</el-table>
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验封面" align='center'>
						<template slot-scope="scope">
							<div class="center_labinfo pointer" @click="getLabInfo(scope.row,3)">
								<img :src="baseurl + scope.row.cover" />
							</div>
						</template>
					</el-table-column>
					<el-table-column label="实验名称" prop="name" align='center' :show-overflow-tooltip='true'>
						<template slot-scope="scope">
							<span class=" pointer" @click="getLabInfo(scope.row,3)">{{scope.row.name}}</span>
						</template>
					</el-table-column>
					<el-table-column label="实验类型" prop="typeName" align='center'>
					</el-table-column>
					<el-table-column label="考核次数" prop="clickNum" align='center'>
						<template slot-scope="scope">
							<span class="successColor">{{scope.row.studyCount || 0}}</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" align='center'>
						<template slot-scope="scope">
							<el-button plain size='medium' @click='tableAppend(scope.row)'>详情</el-button>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="all_current">
				<el-pagination prev-text='上一页' next-text='下一页' background @current-change="labExamCurrent" :current-page="labExamcurrent" :page-size="limit" layout="total,  prev, pager, next" :total="labExamtotal">
				</el-pagination>
			</div>
		</div>
		<el-dialog title="考核操作详情" class="open_dialogInfo" :visible.sync="viewShow" :append-to-body='true' width="1100px" :close-on-click-modal='false' :close-on-press-escape='false'>
			<div class="open_dialogTable">
				<el-table :data="viewForm" height="500" border v-if="viewShow && viewForm && viewType=='1'">
					<el-table-column prop="number" label="步骤序号" align='center' width="50"/>
					<el-table-column prop="title" label="步骤名称" align='center' show-overflow-tooltip width="200" />
					<el-table-column label="得分/满分" align='center' width="100">
						<template slot-scope="scope">
							{{scope.row.score || 0}} / {{scope.row.zfs}}
						</template>
					</el-table-column>
					<el-table-column prop="jgfs" label="及格分数" align='center'>
					</el-table-column>
					<el-table-column prop="createtime" label="操作时间" align='center' width="200">
					</el-table-column>
					<el-table-column prop="useOp" label="我的选项" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.useOp || '-'}}
						</template>
					</el-table-column>
					<el-table-column prop="zqda" label="正确选项" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.zqda || '-'}}
						</template>
					</el-table-column>
				</el-table>
				<el-table :data="viewForm" height="500" border v-if="viewShow && viewForm && viewType=='2'">
					<el-table-column prop="seq" label="步骤序号" align='center' width="50"/>
					<el-table-column prop="title" label="步骤名称" align='center' show-overflow-tooltip width="200" />
					<el-table-column label="得分/满分" align='center'>
						<template slot-scope="scope">
							{{scope.row.score || 0}} / {{scope.row.maxScore}}
						</template>
					</el-table-column>
					<el-table-column label="操作时间" align='center' width="200">
						<template slot-scope="scope">
							<span v-if="scope.row.timeUsed == 0">
							未作答
						</span>
							<span v-if="scope.row.timeUsed != 0">
							{{scope.row.startTime}} - {{scope.row.endTime}}
						</span>
						</template>
					</el-table-column>
					<el-table-column label="用时/规定用时" align='center' width="150">
						<template slot-scope="scope">
							{{scope.row.timeUsed}}秒 / {{scope.row.expectTime || 0}}秒
						</template>
					</el-table-column>
					<el-table-column prop="repeatCount" label="操作次数" align='center' />
					<el-table-column prop="evaluation" label="步骤评价" align='center' show-overflow-tooltip/>
					<el-table-column prop="scoringModel" label="赋分模型" align='center' show-overflow-tooltip/>
					<el-table-column prop="remarks" label="备注" align='center' show-overflow-tooltip>
						<template slot-scope="scope">
							{{scope.row.remarks || '-'}}
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="center_btns">
				<el-button type='primary' @click="viewShow = false">确定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import { getStorageToken } from '@/utils/auth'
	import { listMajorByPid } from '@/api/major'
	import { personalVrStudyRecord, personalVrExamineRecord, vrPaperUserInit, clickInsert, saveResourceScore, removeResourceScore, getResourceScore, getResourceDetail, getResourceDetailClicks, userIsCollection, getResourceDetailRecord, saveResourceDetailRecord, userCollectionSave, userCollectionRemove, userScoreStepList, userDataStepList } from '@/api/simulation.js'
	export default {
		data() {
			return {
				activeName: '1',
				commNavs: [{
					name: '学习模式',
					id: '1'
				}, {
					name: '考核模式',
					id: '2'
				}],
				limit: 10,
				typeList: [],
				//学习
				labTestData: [],
				labTestcurrent: 1,
				labTesttotal: 0,
				labTestname: '',
				labTesttypeId: '',
				//考核
				labExamData: [],
				labExamcurrent: 1,
				labExamtotal: 0,
				labExamname: '',
				labExamtypeId: '',

				//考核详情
				viewType: '',
				viewShow: false,
				viewForm: {},
			};
		},
		created() {
			this.getTypeList();
			this.getLabTestData();
			this.getLabExamData();
		},
		methods: {
			labTestCurrent(labTestcurrent) {
				this.labTestcurrent = labTestcurrent;
				this.getLabTestData();
			},
			getLabTestData() {
				var data = {
					name: this.labTestname ? this.labTestname : null,
					typeId: this.labTesttypeId ? this.labTesttypeId : null,
					majorId: this.majorIdForAll,
					current: this.labTestcurrent,
					limit: this.limit,
				}
				personalVrStudyRecord(data).then(res => {
					if(res.code == "OK") {
						this.labTestData = res.data.records
						this.labTesttotal = res.data.total
					}
				})
			},
			clearLabTestFilter() {
				this.labTestname = '';
				this.labTesttypeId = '';
				this.labTestcurrent = 1;
				this.getLabTestData();
			},
			tableAppend(row) {
				this.$refs.centerTable.toggleRowExpansion(row)
			},
			labExamCurrent(labExamcurrent) {
				this.labExamcurrent = labExamcurrent;
				this.getLabExamData();
			},
			getLabExamData() {
				var data = {
					name: this.labExamname ? this.labExamname : null,
					typeId: this.labExamtypeId ? this.labExamtypeId : null,
					majorId: this.majorIdForAll,
					current: this.labExamcurrent,
					limit: this.limit,
				}
				personalVrExamineRecord(data).then(res => {
					if(res.code == "OK") {
						this.labExamData = res.data.records
						this.labExamtotal = res.data.total
					}
				})
			},
			clearLabExamFilter() {
				this.labExamname = '';
				this.labExamtypeId = '';
				this.labExamcurrent = 1;
				this.getLabExamData();
			},
			getTypeList() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.typeList = res.data;
				})
			},
			getLabInfo(item,type) {
				var resourceId = "";
				if(type == '3'){
					resourceId = item.vrResourceStudy.id;
				}
				if(type == '2'){
					resourceId = item.vrResourceExamine.id;
				}
				this.$router.push({
					name: 'fictitiousinfo',
					query: {
						vrDetailId: item.id,
						resourceId: resourceId,
					}
				})
			},
			scoreSimulation(record, vrDetail) {
				if(vrDetail.vrResourceExamine && vrDetail.vrResourceExamine.version == '1.0.0') {
					userScoreStepList({
						paperId: record.id
					}).then(res => {
						if(res.code == "OK") {
							this.viewType = '1';
							this.viewForm = res.data.list;
							this.viewShow = true;
						}
					})
				}
				if(vrDetail.vrResourceExamine && vrDetail.vrResourceExamine.version == '2.0.0') {
					userDataStepList({
						dataId: record.id
					}).then(res => {
						if(res.code == "OK") {
							this.viewType = '2';
							this.viewForm = res.data;
							this.viewShow = true;
						}
					})
				}
			},
			viewSimulation(item, resource) {
				var vrDetailId = item.id;
				var resourceId = resource.id;
				var token = getStorageToken();
				if(token) {
					saveResourceDetailRecord({
						vrDetailId: vrDetailId,
						resourceId: resourceId,
					}).then(res => {
						if(resource.mode && resource.mode == '2') {
							if(resource.version == '2.0.0') {
								window.open('#/fictitiousdetail?type=exam&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
							} else {
								vrPaperUserInit({
									vrDetailId: vrDetailId,
									resourceId: resourceId,
									expertype: item.typeId,
								}).then(res => { //判断是否有关联的试卷，存在则直接返回，不存在则创建后返回
									if(res.code == 'OK') {
										window.open('#/fictitiousdetail?type=index&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId + '&pid=' + res.data)
									}
								})
							}
						} else {
							window.open('#/fictitiousdetail?type=test&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},

		}
	}
</script>